import { render, staticRenderFns } from "./EmployeeAvatarDialog.vue?vue&type=template&id=a7826b70&scoped=true&"
import script from "./EmployeeAvatarDialog.vue?vue&type=script&lang=js&"
export * from "./EmployeeAvatarDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAvatarDialog.vue?vue&type=style&index=0&id=a7826b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7826b70",
  null
  
)

export default component.exports